import React from 'react';
import { StickyNavigation } from '../../ui-toolkit/components';
import { UserProfileContainer } from '../../components/userProfile/UserProfileContainer';
import { LenderCompaniesPage } from './LenderCompaniesPage';

export const LenderCompaniesContainer: React.FC = () => {
  return (
    <>
      <StickyNavigation activeMain={'Lenders'} profile={<UserProfileContainer />} />
      <LenderCompaniesPage />
    </>
  );
};
